<template>
  <div class="contact-info">
    <small>
      <div>Customer Support</div>
      <div><a href="mailto:support@twiagemed.com">support@twiagemed.com</a></div>
      <div><a href="tel:888 589 4243">(888) 589-4243</a></div>
      <div><a href="tel:646 968 0204">(646) 968-0204</a></div>
    </small>
  </div>
</template>

<script>
export default {
  name: "ContactInfo"
};
</script>

<style scoped>
.contact-info {
  text-align: center;
}
</style>
